import { DocumentExportApiClient, TargetSystem } from '@/clients/documentExportApiClient';

export class DocumentExportService {
  async exportDocuments(
    fiscalYearId: string,
    targetSystem: TargetSystem,
    filename: string
  ): Promise<void> {
    return DocumentExportApiClient.exportDocuments(fiscalYearId, targetSystem, filename);
  }
}
